import React, { useContext, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import usePost from '../hooks/usePost';
import Error from './error';
import Loading from './loading';
import Header from './header';
import UsersSerialsContext from '../contexts/users-serials-context';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export default function ProductPage() {
  const classes = useStyles();

  const [product, setProduct] = useState('');

  const { setSerial } = useContext(UsersSerialsContext);

  const [response, addProduct] = usePost({
    path: 'main',
    payload: { btn: 'register_product', serial: product },
  });

  function onSubmit(event: any) {
    event.preventDefault();
    addProduct();
  }

  useEffect(() => {
    if (!!response.message && response.message.length > 0) {
        setSerial(response.data);
    }
  }, [response, setSerial]);


  return (
    <Container className={classes.container} maxWidth='xs'>
      <Header
        links={[
          { to: '/users-serials', name: 'Products' },
          { to: '/logout', name: 'Logout' },
        ]}
      />
      <form onSubmit={onSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Product'
                  name='product'
                  size='small'
                  variant='outlined'
                  defaultValue={product}
                  onChange={(evt) => setProduct(evt.target.value)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Button
              style={{ backgroundColor: '#1d4589', color: '#F79420' }}
              fullWidth
              type='submit'
              variant='contained'
            >
              Register Product
            </Button>
          </Grid>
        </Grid>
      </form>
      {!!response.error && <Error error={response.error} />}
      {!!response.message && (
        <div>
          <h2>{response.message}</h2>
        </div>
      )}
      <Loading loading={response.isLoading} />
    </Container>
  );
}
